module.exports = __webpack_public_path__ + "media/images/flags/1x1/ata-c08fe1995c621ab8634304fbfe5b6e7c.svg";